var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.5C8.4825 0.5 10.5 2.5175 10.5 5C10.5 8.375 6 13.25 6 13.25C6 13.25 1.5 8.375 1.5 5C1.5 2.5175 3.5175 0.5 6 0.5ZM11.25 15.5V14H0.75V15.5H11.25ZM3 5C3 3.3425 4.3425 2 6 2C7.6575 2 9 3.3425 9 5C9 6.5975 7.44 9.095 6 10.9325C4.56 9.1025 3 6.5975 3 5ZM4.5 5C4.5 4.175 5.175 3.5 6 3.5C6.825 3.5 7.5 4.175 7.5 5C7.5 5.825 6.8325 6.5 6 6.5C5.175 6.5 4.5 5.825 4.5 5Z",
    fill: "#008B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinGreen);
export default __webpack_public_path__ + "static/media/pin-green.d37577b36084433adb7bf351c07ec5ef.svg";
export { ForwardRef as ReactComponent };